import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonInput,
  IonItem,
  IonLabel,
  IonNote,
  IonPage,
  useIonLoading,
  useIonToast,
} from '@ionic/react';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { AppContext } from '../../lib/context/AppContext';

const ForgotPassword: React.FC = (props) => {
  const { apiService } = useContext(AppContext);
  const [present] = useIonToast();
  const [presentLoading, dismissLoading] = useIonLoading();
  let history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ reValidateMode: 'onChange', mode: 'onChange' });

  return (
    <IonPage>
      <IonContent fullscreen>
        <div className='h-screen flex items-center justify-center'>
          <IonCard className='w-full max-w-md'>
            <IonCardHeader>
              <IonCardTitle>Recupera password</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <form
                onSubmit={handleSubmit(async (data) => {
                  presentLoading(undefined, undefined, 'lines');
                  apiService?.post('/auth/forgot-password', data).then(
                    (response) => {
                      dismissLoading();
                      present({
                        message: 'Email di recupero inviata',
                        position: 'top',
                        duration: 2500,
                      });
                      history.replace('/auth/sign-in');
                    },
                    (error) => {
                      dismissLoading();
                      present({
                        message:
                          error.response?.data?.error?.message ||
                          'Errore durante il reset della password',
                        duration: 2500,
                        position: 'top',
                        color: 'danger',
                      });
                    }
                  );
                })}
              >
                <IonItem
                  fill='solid'
                  className={`${!errors.email && 'ion-valid'} 
                  ${!!errors.email && 'ion-invalid'} `}
                >
                  <IonLabel position='floating'>Email</IonLabel>
                  <IonInput
                    type='email'
                    {...register('email', { required: true })}
                  ></IonInput>
                  <IonNote slot='error'>Email non valida</IonNote>
                </IonItem>

                <div className='mt-8 flex justify-end'>
                  <IonButton type='submit'>Invia email</IonButton>
                </div>
              </form>

              <div className='border-top w-full h-[1px] bg-gray-300 my-4 relative'>
                <span className='bg-white absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-2'>
                  Oppure
                </span>
              </div>
              <div className='mt-8'>
                <IonButton routerLink='sign-in' expand='block' fill='clear'>
                  Accedi
                </IonButton>
              </div>
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ForgotPassword;
